import React, { useEffect, useRef, useState } from "react";
import back from "../../Assets/Image/admin/back.png";
import { useNavigate, useParams } from "react-router-dom";
import deletes from "../../Assets/Image/admin/delete.png";
import { Dumbbell, Shield, ShieldBan, X } from "lucide-react";
import Dialog from "../../Base-Component/Dialog/Dialog";
import { Bars, Circles } from "react-loader-spinner";
import like from "../../Assets/Image/admin/like.png";
import comment from "../../Assets/Image/admin/comment.png";
import { IMG_URL } from "../../Services/Api";
import placeholderImg from "../../Assets/Image/admin/placeholder.jpg";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { blockUnblockUser, deletepost, deleteUsers, userDetails, userPost } from "../../Services/ApiServices";
import { GoDotFill } from "react-icons/go";
import * as Yup from "yup";
import { BsTelephone, BsThreeDotsVertical } from "react-icons/bs";
import { HiOutlineMail } from "react-icons/hi";
import ProgressBar from "../../Base-Component/ProgressBar/ProgressBar";
import view from "../../Assets/Image/admin/view.png";
import Menu from "../../Base-Component/Menu/Menu";
import { IoIosWarning } from "react-icons/io";
import Hls from "hls.js";


function UserDetails() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [isModalOpens, setModalOpens] = useState(false);
  const [workOutDetailsModal, setWorkOutDetailsModal] = useState(false);
  const [isBlockUser, setIsBlockUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenLike, setIsOpenLike] = useState(false);
  const [supplementModal, setSupplementModal] = useState(false);
  const [postDetailsModal, setPostDetailsModal] = useState(false);
  const [isOpenComment, setIsOpenComment] = useState(false);
  const [isDeletePost, setIsDeletePost] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [totalPage, setTotalPage] = useState("1");
  const [userId, setUserId] = useState({});
  const [dialogType, setDialogType] = useState("");
  const [isUnblock, setIsUnblock] = useState(false);
  const [postIdToDelete, setPostIdToDelete] = useState({});
  const [usersData, setUsersData] = useState({});
  const [profileDetails, setProfileDetails] = useState({});
  const [workoutsData, setWorkoutsData] = useState({});
  const [supplemnetData, setSupplemnetData] = useState({});
  const [postData, setPostData] = useState({});
  const [postLikes, setPostLikes] = useState([]);
  const [postComments, setPostComments] = useState([]);
  const [activeTab, setActiveTab] = useState("workouts");
  const [loader, setLoader] = useState(false);
  const [isUserPost, setIsUserPost] = useState([]);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handleViewAction = (data, action) => {
    setUserId(data);

    if (action === "block") {
      setDialogType("block");
      setIsBlockUser(true);
    } else if (action === "unblock") {
      setDialogType("unblock");
      setIsUnblock(true);
    } else if (action === "delete") {
      setDialogType("delete");
      setModalOpens(true);
    }
  };

  const validationSchema = Yup.object().shape({
    reason: Yup.string()
      .trim()
      .required("Reason is required")
  });


  const formik = useFormik({
    initialValues: {
      reason: ''
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      setIsLoading(true);

      if (dialogType === "block") {
        let obj = {
          user_id: userId?.id,
          reason: values?.reason,
        };
        blockUnblockUser(obj)
          .then((res) => {
            if (res?.status === 200) {
              toast.success(res?.data?.message);
              resetForm();
            }
            setIsBlockUser(false);
            getUsersDetails()
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message);
            setIsLoading(false);
          });
      } else if (dialogType === "delete") {
        let obj = {
          user_id: userId?.id,
          reason: values?.reason,
        };

        deleteUsers(obj)
          .then((res) => {
            if (res?.status === 200) {
              toast.success(res?.data?.message);
              resetForm();
              navigate("/users")
            }
            setModalOpens(false);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message);
            setIsLoading(false);
          });
      } else if (postIdToDelete) {
        let obj = {
          post_id: postIdToDelete,
          reason: values?.reason,
        };

        deletepost(obj)
          .then((res) => {
            if (res?.status === 200) {
              toast.success(res?.data?.message);
              resetForm();
              getUserPost();
            }
            setIsDeletePost(false);
            setModalOpens(false)
            setIsLoading(false);
          }).catch((err) => {
            toast.error(err?.response?.data?.message);
            setIsLoading(false);
          });
      }
    }
  });

  const handleDeleteClose = () => {
    setModalOpens(false);
    formik?.resetForm();
  };

  const handleUnblock = () => {
    setIsLoading(true);
    let obj = {
      user_id: userId?.id,
    };

    blockUnblockUser(obj)
      .then((res) => {
        if (res?.status === 200) {
          toast.success(res?.data?.message);
        }
        setIsUnblock(false);
        getUsersDetails()
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsLoading(false);
      });
  };

  const getUsersDetails = () => {
    setLoader(true);
    userDetails(id)
      .then((res) => {
        setUsersData(res?.data?.data);
        setProfileDetails(res?.data)
        setLoader(false);
      }).catch((err) => {
        console.log(err, "error");
        setLoader(false);
      })
  };

  const getUserPost = () => {
    let obj = {
      user_id: id,
      page: pageNo,
    };

    userPost(obj)
      .then((res) => {
        setIsUserPost(res?.data?.data);
        setTotalPage(res?.data?.pagination?.totalPages);
      }).catch((err) => {
        console.log(err, "error");
      });
  };

  useEffect(() => {
    getUsersDetails();
    getUserPost();
  }, [pageNo]);

  const HLSVideo = ({ src }) => {
    const videoRef = useRef(null);

    useEffect(() => {
      const video = videoRef.current;
      if (video && Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(video);
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = src;
      }
    }, [src]);

    return (
      <video ref={videoRef} className="w-full md:h-[300px] h-[250px] rounded-xl object-cover" controls />
    );
  };

  return (
    <>
      {loader ? (
        <div className="flex justify-center items-center col-span-12 h-[70vh]">
          <Bars
            height="35"
            width="35"
            color="#FF4433"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      ) : (
        <div className="md:m-4 m-1 fontNew">
          <div className="flex items-center cursor-pointer mb-4">
            <img
              src={back}
              onClick={() => {
                if (usersData.is_blocked === true) {
                  return navigate("/users", { state: { flag: 1 } });
                } else {
                  return navigate("/users", { state: { flag: 0 } });
                }
              }}
              className="w-4"
              alt=""
            />
            <p
              onClick={() => {
                if (usersData.is_blocked === true) {
                  return navigate("/users", { state: { flag: 1 } });
                } else {
                  return navigate("/users", { state: { flag: 0 } });
                }
              }}
              className="text-base font-medium ms-3"
            >
              Go back
            </p>
          </div>
          <div className="w-full">
            <div className="w-full grid grid-cols-12 gap-5 bg-white rounded-xl p-5">
              <div className="bg-[#F9F9F9] md:col-span-9 col-span-12 rounded-xl p-4">
                <div className="flex relative justify-between">
                  <div className="flex md:flex-row flex-col items-center md:w-fit w-full justify-start gap-x-10">
                    <div className="flex items-center">
                      <img
                        src={usersData.profile_image ? IMG_URL + usersData?.profile_image : placeholderImg}
                        crossOrigin="anonymous"
                        className="w-[140px] h-[140px] rounded-full border-[3px] object-cover border-white"
                        alt=""
                      />
                    </div>
                    <div className="md:text-start text-center">
                      <h1 className="text-lg font-semibold mb-3">
                        {usersData.firstname || ""} {usersData.lastname || ""}
                      </h1>
                      {usersData.phone_number === "" || usersData.phone_number === null ? (
                        <div className="flex w-full md:justify-start justify-center items-center mb-3">
                          <HiOutlineMail className="text-sm" />
                          <p className="ml-1 text-sm font-medium text-gray-500">
                            {usersData.email_id || ""}
                          </p>
                        </div>
                      ) : (
                        <div className="flex items-center w-full md:justify-start justify-center mb-3">
                          <BsTelephone className="text-sm" />
                          <p className="ml-1 text-sm font-medium text-gray-500">
                            {usersData.country_code || ""}{" "}
                            {usersData.phone_number || ""}
                          </p>
                        </div>
                      )}
                      <div className="flex items-start gap-x-10">
                        <div className="flex sm:flex-row flex-col gap-1 items-center">
                          <h2 className="text-lg font-semibold ">{profileDetails.postsCount}</h2>
                          <span className="text-sm text-gray-400 font-medium">Posts</span>
                        </div>
                        <div className="flex sm:flex-row flex-col gap-1 items-center">
                          <h2 className="text-lg font-semibold">{profileDetails.followersCount}</h2>
                          <span className="text-sm text-gray-400 font-medium">Followers</span>
                        </div>
                        <div className="flex sm:flex-row flex-col gap-1 items-center">
                          <h2 className="text-lg font-semibold">{profileDetails.followingCount}</h2>
                          <span className="text-sm text-gray-400 font-medium">Following</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex sm:flex-row flex-col absolute top-0 right-0 items-center justify-center gap-2 cursor-pointer">
                    <div
                      className="bg-[#5570F129] lg:w-9 w-8 lg:h-9 h-8 rounded-full flex items-center justify-center"
                    >
                      {usersData?.is_blocked === false ? (
                        <div onClick={() => handleViewAction(usersData, "block")} className="bg-[#556ff109] w-9 h-9 rounded-full flex items-center justify-center">
                          <ShieldBan color="#5570F1" size={17} />
                        </div>
                      ) : (
                        <div onClick={() => handleViewAction(usersData, "unblock")} className="bg-[#556ff109] w-9 h-9 rounded-full flex items-center justify-center">
                          <Shield color="blue" size={17} />
                        </div>
                      )}
                    </div>
                    <img
                      onClick={() => handleViewAction(usersData, "delete")}
                      src={deletes}
                      className="lg:w-9 w-8 lg:h-9 h-8"
                      alt=""
                    />
                  </div>
                </div>
                {usersData.reason && <div className="bg-red-50 h-fit items-center flex gap-x-2 py-2 px-4 md:w-[50%] sm:w-[80%] w-full rounded-xl mt-4">
                  <div className="max-w-12 h-fit">
                    <IoIosWarning className="text-red-500" />
                  </div>
                  <span className="md:text-sm text-xs font-normal text-red-500">
                    {usersData.reason || ""}
                  </span>
                </div>}
                <h2 className="text-sm flex gap-2 text-gray-600 font-semibold mt-3">
                  {usersData.gym_address && <Dumbbell size={20} />}
                  {usersData.gym_address || ""}
                </h2>
                <div className="mt-2">
                  <p className="text-gray-500 md:text-base text-sm font-normal">{usersData.profession || ""}</p>
                </div>
                <div className="md:w-[60%] w-full mt-3">
                  <ProgressBar level={usersData.level || 0} exp={usersData.exp || 0} maxExp={10} />
                </div>
              </div>
              <div className="bg-[#F9F9F9] md:col-span-3 col-span-12 rounded-xl p-4">
                <h2 className="text-lg font-semibold text-black mb-1">Personal Details :</h2>
                <div className="mt-4 space-y-2">
                  <h3 className="md:text-sm text-xs font-medium text-gray-600">Gender : <span className="text-gray-600">{usersData.gender || " - "}</span></h3>
                  <h3 className="md:text-sm text-xs font-medium text-gray-600">Date of birth : <span className="text-gray-600">{usersData.date_of_birth || ' - '}</span></h3>
                  <h3 className="md:text-sm text-xs font-medium text-gray-600">Height : <span className="text-gray-600">{usersData.height || ' - '}</span></h3>
                  <h3 className="md:text-sm text-xs font-medium text-gray-600">Weight : <span className="text-gray-600">{usersData.weight || ' - '}</span></h3>
                  <h3 className="md:text-sm text-xs font-medium text-gray-600">Goal : <span className="text-gray-600">{usersData.goal || ' - '}</span></h3>
                  <h3 className="md:text-sm text-xs font-medium text-gray-600">Goal weight : <span className="text-gray-600">{usersData.goal_weight || ' - '}</span></h3>
                  <h3 className="md:text-sm text-xs font-medium text-gray-600">Exercise : <span className="text-gray-600">{usersData.excercise || ' - '}</span></h3>
                  <h3 className="md:text-sm text-xs font-medium text-gray-600">Experience level : <span className="text-gray-600">{usersData.experiance_level || ' - '}</span></h3>
                </div>
              </div>
            </div>
            <div className="col-span-12 mt-5">
              <h4 className="text-lg font-semibold">User Workout</h4>
              <div className=" flex items-center justify-center bg-white rounded-full w-fit h-[50px] mx-auto p-1 shadow-md">
                <button
                  className={`px-5 py-2 text-sm font-normal rounded-full transition-all ${activeTab === "workouts"
                    ? "bg-red-500 text-white"
                    : "bg-transparent text-black"
                    }`}
                  onClick={() => setActiveTab("workouts")}
                >
                  Workouts
                </button>

                <button
                  className={`px-5 py-2 text-sm font-normal rounded-full transition-all ${activeTab === "supplements"
                    ? "bg-red-500 text-white"
                    : "bg-transparent text-black"
                    }`}
                  onClick={() => setActiveTab("supplements")}
                >
                  Supplements
                </button>
              </div>
              <div>
                <div className={`grid grid-cols-12 gap-5 py-3 ${activeTab === "supplements" && "md:max-h-[500px] max-h-[400px] scroll overflow-y-auto"}`}>
                  {activeTab === "workouts" &&
                    <>
                      {usersData?.user_workouts?.length > 0 ? usersData?.user_workouts?.map((item, index) => (
                        <div className="2xl:col-span-3 lg:col-span-4 sm:col-span-6 col-span-12 bg-white hover:shadow-lg duration-200 cursor-pointer rounded-xl p-4 "
                          onClick={() => {
                            setWorkOutDetailsModal(true)
                            setWorkoutsData(item)
                          }}>
                          <div className="flex items-center justify-between">
                            <h4 className="text-[18px] font-semibold">{item?.day}</h4>
                            <p className="text-xs text-[#F24434]">{item?.workout_name}</p>
                          </div>
                          <div className="mt-4 w-full">
                            <div className="text-sm font-normal mb-1">Exercise</div>
                            {item?.workout_excercise.map((i, index) => (
                              <span key={index} className="text-black text-xs">
                                {i?.excercise_workout?.excercise_name}
                                {index !== item?.workout_excercise.length - 1 && (
                                  <GoDotFill className="inline-block mx-1 text-[#F24434] text-[10px]" />
                                )}
                              </span>
                            ))}
                          </div>
                        </div>
                      ))
                        :
                        <div className="w-full col-span-12 h-[200px] flex items-center justify-center">
                          <p className="md:text-[15px] text-sm  font-medium w-full  text-center text-gray-400">No Workout details available</p>
                        </div>
                      }
                    </>
                  }

                  {activeTab === "supplements" && <>
                    {usersData?.user_suppliment?.length > 0 ? usersData?.user_suppliment?.map((item, index) => (
                      <div className="2xl:col-span-3 relative lg:col-span-4 sm:col-span-6 col-span-12 hover:shadow-lg duration-200 cursor-pointer bg-white rounded-xl p-4">
                        <div>
                          <p className="md:text-base text-black font-semibold text-sm mb-1">{item.suppliment_name || ""}</p>
                          <span className="md:text-sm text-black font-medium text-xs">{item.sub_name}</span>
                          <p className="md:text-sm text-xs text-gray-400 break-words line-clamp-2 mt-2">{item.note || ""}</p>
                        </div>
                        <p className="md:text-base text-sm mt-2">{item.quantity || ""}</p>
                        <button className="absolute bottom-2 right-2" onClick={() => {
                          setSupplementModal(true);
                          setSupplemnetData(item);
                        }}>
                          <img
                            src={view}
                            className="w-7"
                            alt="view"
                          />
                        </button>
                      </div>
                    ))
                      :
                      <div className="w-full col-span-12 h-[200px] flex items-center justify-center">
                        <p className="md:text-[15px] text-sm font-medium w-full text-center text-gray-400">No Suppliment available</p>
                      </div>
                    }
                  </>}
                </div>
              </div>
            </div>
            <div className="col-span-12 py-3">
              <h4 className="text-lg font-semibold">User Posts</h4>
              <div className="grid grid-cols-12 gap-4  mt-4">
                {isUserPost && isUserPost?.map((item, index) => (
                  <div key={index} className="2xl:col-span-3 md:col-span-6 col-span-12 bg-white rounded-xl p-4">
                    {item?.post_images?.map((imageUrl, imageIndex) => {
                      const postUrl = imageUrl?.post_url;

                      if (imageUrl.type == 1) {
                        if (postUrl.endsWith('.mp4') || postUrl.endsWith('.avi') || postUrl.endsWith('.mov') || postUrl.endsWith('.webm')) {
                          return (
                            <video key={imageIndex} className="w-full h-[300px] rounded-xl object-cover" controls>
                              <source src={IMG_URL + postUrl} type={`video/${postUrl.split('.').pop()}`} />
                              Your browser does not support the video tag.
                            </video>
                          );
                        } else if (postUrl.endsWith('.m3u8')) {
                          return <HLSVideo key={imageIndex} src={IMG_URL + postUrl} />;
                        }
                      }

                      return (
                        <img
                          key={imageIndex}
                          src={postUrl ? IMG_URL + postUrl : placeholderImg}
                          alt="Post"
                          className="w-full md:h-[300px] h-[250px] rounded-xl object-cover"
                        />
                      );
                    })}
                    <div className="mt-3.5 flex items-center justify-between">
                      <div className="flex w-full justify-between items-center">
                        <div className="flex items-center gap-2.5">
                          <div className="flex items-center gap-1.5 cursor-pointer" onClick={() => {
                            setIsOpenLike(true)
                            setPostLikes(item.likes)
                          }}>
                            <img src={like} alt="..." className="w-3.5" />
                            <span className="text-sm">{item?.likes?.length || 0}</span>
                          </div>
                          <div className="flex items-center gap-1.5 cursor-pointer" onClick={() => {
                            setIsOpenComment(true)
                            setPostComments(item.comments)
                          }}>
                            <img src={comment} alt="..." className="w-5" />
                            <span className="text-sm">{item?.comments?.length || 0}</span>
                          </div>
                        </div>
                        <Menu className={`mt-2`}>
                          <Menu.Button className="block">
                            <BsThreeDotsVertical className="text-xl" />
                          </Menu.Button>
                          <Menu.Items className="w-56 bg-white mt-5 fontNew">
                            <Menu.Item
                              className="hover:bg-gray-50 border-b border-gray-100 text-[#303438] flex justify-between items-center py-2"
                            >
                              <div className="flex w-full items-center"
                                onClick={() => {
                                  setPostDetailsModal(true)
                                  setPostData(item)
                                }}>
                                <img
                                  src={view}
                                  className="lg:w-9 w-8"
                                  alt="view"
                                />
                                <p className="m-0 ms-3">View Details</p>
                              </div>
                            </Menu.Item>
                            <Menu.Item
                              className="hover:bg-gray-50 text-[#303438] flex justify-between items-center py-2"
                            >
                              <div className="flex w-full items-center"
                                onClick={() => {
                                  setPostIdToDelete(item?.id)
                                  setIsDeletePost(true);
                                }}>
                                <img
                                  src={deletes}
                                  className="lg:w-9 w-8"
                                  alt="Delete"
                                />
                                <p className="m-0 ms-3">Delete</p>
                              </div>
                            </Menu.Item>
                          </Menu.Items>
                        </Menu>
                      </div>
                    </div>
                    <div className="mt-3.5">
                      <p className="md:text-base text-sm font-medium">{item?.post_type || ''}</p>
                      <p className="text-sm text-gray-400 font-normal">{item?.caption_message || ""}</p>
                    </div>
                  </div>
                ))}
                {isUserPost.length > 0 ? <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
                  :
                  <div className="w-full col-span-12 h-[100px] flex items-center justify-center">
                    <p className="md:text-[15px]  text-sm font-medium text-center text-gray-400">No posts available</p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      )}

      <Dialog
        open={isBlockUser}
        onClose={() => setIsBlockUser(false)} size="2xl"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center  my-4 sm:px-16 px-4 fontNew">

              <div>
                <h4 className="text-xl text-center font-semibold text-black mt-6">
                  Block User?
                </h4>
                <form onSubmit={formik?.handleSubmit}>
                  <div className="my-3">
                    <label className="text-base">Reason :</label>
                    <textarea
                      name="reason"
                      value={formik.values.reason}
                      rows={5}
                      className={`bg-transparent px-4 pt-2 rounded-xl border-2 w-full outline-secondary text-base mt-2 ${formik.errors.reason && formik.touched.reason
                        ? "border-red-500"
                        : "border-slate-300"
                        }`}
                      placeholder="Enter the reason"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.reason && formik.touched.reason && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.reason}
                      </p>
                    )}
                  </div>
                  <div className="mt-7 flex items-center mb-5">
                    <button
                      className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                      onClick={() => setIsBlockUser(false)}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="bg-primary h-[50px] disabled:bg-red-400 sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    >
                      {isLoading ? (
                        <div className="flex justify-center">
                          <Circles
                            width={25}
                            height={25}
                            color="#fff"
                            ariaLabel="circles-loading"
                            wrapperStyle={{}}
                            visible={true}
                            wrapperClass=""
                          />
                        </div>
                      ) : (
                        "Block"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isUnblock}
        onClose={() => setIsUnblock(false)}
        size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center  my-4 sm:px-16 px-4 fontNew">

              <div>
                <h4 className="text-xl text-center font-semibold text-black mt-6">
                  UnBlock User?
                </h4>
                <p className="text-base text-gray-500 my-3">
                  Are you sure you want to unblock this User?
                </p>
                <div className="mt-7 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsUnblock(false)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    disabled={isLoading}
                    className="bg-primary h-[50px] disabled:bg-red-400 sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={() => handleUnblock()}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "UnBlock"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => handleDeleteClose()}
        size="md">
        <Dialog.Panel>
          <Dialog.Description className="">
            <div className="flex justify-center mt-4">
              <img
                src={usersData.profile_image ? IMG_URL + usersData?.profile_image : placeholderImg}
                className="object-cover rounded-full h-[100px] w-[100px]"
                alt=""
              />
            </div>
            <div className="flex justify-center mt-5 sm:px-16 px-5 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black text-center">
                  Delete User?
                </h4>
                <form onSubmit={formik?.handleSubmit}>
                  <div className="my-3">
                    <label className="text-base">Reason :</label>
                    <textarea
                      name="reason"
                      value={formik.values.reason}
                      rows={5}
                      className={`bg-transparent px-4 pt-2 rounded-xl border-2 w-full outline-secondary text-base mt-2 ${formik.errors.reason && formik.touched.reason
                        ? "border-red-500"
                        : "border-slate-300"
                        }`}
                      placeholder="Enter the reason"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.reason && formik.touched.reason && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.reason}
                      </p>
                    )}
                  </div>
                  <div className="flex items-center justify-center mt-7 mb-10">
                    <button
                      type="button"
                      className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                      onClick={() => handleDeleteClose()}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="bg-[#ea5f5f] h-[50px] sm:w-36 disabled:bg-red-400 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    >
                      {isLoading ? (
                        <div className="flex justify-center">
                          <Circles
                            width={25}
                            height={25}
                            color="#fff"
                            ariaLabel="circles-loading"
                            wrapperStyle={{}}
                            visible={true}
                            wrapperClass=""
                          />
                        </div>
                      ) : (
                        "Delete"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isOpenLike}
        onClose={() => setIsOpenLike(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="my-4 sm:px-8 px-4 fontNew max-h-[370px] overflow-y-auto">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-center flex-grow">Users like</h3>
                <X className="w-5 h-5 cursor-pointer" onClick={() => setIsOpenLike(false)} />
              </div>
              <div className="md:max-h-[500px] max-h-[400px]">
                {postLikes.length > 0 ? postLikes?.map((item, index) => (
                  <div key={index} className={`py-2.5 border-b-2 last:border-none border-[#f1f1f1]`}>
                    <div className="flex items-center">
                      <img
                        src={
                          item?.user?.profile_image ? IMG_URL + item?.user?.profile_image : placeholderImg
                        }
                        className="w-10 h-10 rounded-full object-cover"
                        alt=""
                      />
                      <p className="md:text-base text-sm ms-3">
                        {item?.user?.firstname || "-"}{" "}
                        {item?.user?.lastname || ""}
                      </p>
                    </div>
                  </div>
                )) :
                  <p className="md:text-[15px] text-sm mt-10 font-medium w-full col-span-12 text-center text-gray-400">No likes available</p>
                }
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isOpenComment}
        onClose={() => setIsOpenComment(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="sm:px-8 px-4 my-4 fontNew max-h-[370px] overflow-y-auto">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-center flex-grow">Users comment</h3>
                <X className="w-5 h-5 cursor-pointer" onClick={() => setIsOpenComment(false)} />
              </div>
              <div className="md:max-h-[500px] max-h-[400px]">
                {postComments.length > 0 ? postComments?.map((item, index) => (
                  <div key={index} className={`py-2.5 border-b-2 last:border-none border-[#f1f1f1]`}>
                    <div className="flex items-center">
                      <img
                        src={
                          item?.commented_user?.profile_image ? IMG_URL + item?.commented_user?.profile_image : placeholderImg
                        }
                        className="w-10 h-10 rounded-full object-cover"
                        alt=""
                      />
                      <p className="md:text-base text-sm font-semibold ms-3">
                        {item?.commented_user?.firstname || ""}{" "}
                        {item?.commented_user?.lastname || ""}
                      </p>
                    </div>
                    <div className="flex items-center ml-[50px] space-x-1">
                      <img src={comment} alt="..." className="w-5" />
                      <span className="text-gray-500 font-normal md:text-sm text-xs">
                        {item.comment_message || ''}
                      </span>
                    </div>
                  </div>
                )) :
                  <p className="md:text-[15px] text-sm mt-10 font-medium w-full col-span-12 text-center text-gray-400">No comments available</p>
                }
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isDeletePost}
        onClose={() => setIsDeletePost(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center  my-4 sm:px-16 px-5 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-center text-black mt-6">
                  Delete Post?
                </h4>
                <form onSubmit={formik?.handleSubmit}>
                  <div className="my-3">
                    <label className="text-base ">Reason :</label>
                    <textarea
                      type="text"
                      name="reason"
                      rows={4}
                      value={formik?.values?.reason}
                      className={`bg-transparent px-4 pt-2 rounded-xl border-2 w-full outline-secondary text-base mt-2 ${formik.errors.reason && formik.touched.reason
                        ? "border-red-500"
                        : "border-slate-300"
                        }`}
                      placeholder="Enter the reason"
                      onBlur={formik.handleBlur}
                      onChange={formik?.handleChange}
                    />
                    {formik.errors.reason && formik.touched.reason && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.reason}
                      </p>
                    )}
                  </div>
                  <div className="flex items-center justify-center mt-10 mb-10">
                    <button
                      className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                      onClick={() => setIsDeletePost(false)}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="bg-[#ea5f5f] h-[50px] disabled:bg-red-400 sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    >
                      {isLoading ? (
                        <div className="flex justify-center">
                          <Circles
                            width={25}
                            height={25}
                            color="#fff"
                            ariaLabel="circles-loading"
                            wrapperStyle={{}}
                            visible={true}
                            wrapperClass=""
                          />
                        </div>
                      ) : (
                        "Delete"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={workOutDetailsModal}
        onClose={() => setWorkOutDetailsModal(false)}
        size="lg"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="sm:px-8 px-4 my-4 fontNew">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-center flex-grow">Workout Details</h3>
                <X className="w-5 h-5 cursor-pointer" onClick={() => setWorkOutDetailsModal(false)} />
              </div>
              <div className="md:max-h-[550px] max-h-[400px] overflow-y-auto">
                <h2 className="font-medium text-black md:text-base text-sm">{workoutsData.day}</h2>
                <div className="bg-[#F9F9F9] p-4 rounded-xl mt-3">
                  <h2 className="font-medium text-black md:text-lg text-base">{workoutsData.workout_name}</h2>
                  <p className="text-gray-500 md:text-base text-sm font-normal mt-2">{workoutsData.description}</p>
                </div>
                {workoutsData?.workout_excercise?.map((item, index) => (
                  <div className="bg-[#F9F9F9] p-4 rounded-xl mt-3">
                    <h2 className="font-medium text-black md:text-lg text-base">{item.excercise_workout.excercise_name || ''}</h2>
                    <p className="text-gray-500 md:text-base text-sm font-normal mt-1">{item.instruction}</p>
                    {item?.excercise_details?.map((excercise, i) => (
                      <div className="mt-3 flex items-center gap-x-4">
                        <h3 className="md:text-sm text-xs text-black font-normal">{i + 1}</h3>
                        <div className="flex items-center gap-2">
                          <p className="md:text-sm text-xs text-black font-normal">{excercise.kg} <span className="text-gray-400">kg</span></p>
                          <p className="md:text-sm text-xs text-black font-normal">{excercise.reps} <span className="text-gray-400">reps</span></p>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={supplementModal}
        onClose={() => setSupplementModal(false)}
        size="lg"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="sm:px-8 px-4 my-4 fontNew">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-center flex-grow">{supplemnetData.suppliment_name}</h3>
                <X className="w-5 h-5 cursor-pointer" onClick={() => setSupplementModal(false)} />
              </div>
              <div className="md:max-h-[550px] max-h-[400px] overflow-y-auto">
                <h2 className="md:text-lg text-base font-medium">{supplemnetData.sub_name}</h2>
                <h2 className="md:text-base text-sm font-medium mt-2">
                  Quantity : {" "}
                  <span className="text-gray-500">{supplemnetData.quantity}</span>
                </h2>
                <p className="text-black md:text-base break-words text-sm font-medium mt-3">
                  Note : {" "}
                  <span className="text-gray-500 font-normal">
                    {supplemnetData.note}
                  </span>
                </p>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={postDetailsModal}
        onClose={() => setPostDetailsModal(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="sm:px-8 px-4 my-4 fontNew">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl font-semibold text-center flex-grow">Post Details</h3>
                <X className="w-5 h-5 cursor-pointer" onClick={() => setPostDetailsModal(false)} />
              </div>
              <div className="md:max-h-[550px] max-h-[400px] overflow-y-auto">
                {postData?.post_images?.map((imageUrl, imageIndex) => {
                  const postUrl = imageUrl?.post_url;

                  if (imageUrl.type == 1) {
                    if (postUrl.endsWith('.mp4') || postUrl.endsWith('.avi') || postUrl.endsWith('.mov') || postUrl.endsWith('.webm')) {
                      return (
                        <video key={imageIndex} className="w-full h-[300px] rounded-xl object-cover" controls>
                          <source src={IMG_URL + postUrl} type={`video/${postUrl.split('.').pop()}`} />
                          Your browser does not support the video tag.
                        </video>
                      );
                    } else if (postUrl.endsWith('.m3u8')) {
                      return <HLSVideo key={imageIndex} src={IMG_URL + postUrl} />;
                    }
                  }
                  return (
                    <img
                      key={imageIndex}
                      src={postUrl ? IMG_URL + postUrl : placeholderImg}
                      alt="Post"
                      className="w-full md:h-[300px] h-[250px] rounded-xl object-cover"
                    />
                  );
                })}
                <div className="flex items-center gap-2.5 mt-3">
                  <div className="flex items-center gap-1.5 cursor-pointer">
                    <img src={like} alt="..." className="w-3.5" />
                    <span className="text-sm">{postData?.likes?.length || 0}</span>
                  </div>
                  <div className="flex items-center gap-1.5 cursor-pointer">
                    <img src={comment} alt="..." className="w-5" />
                    <span className="text-sm">{postData?.comments?.length || 0}</span>
                  </div>
                </div>
                {postData?.post_type && <div className="mt-3">
                  <p className="md:text-sm font-medium text-sm">
                    Post type : {' '}
                    <span className="text-gray-500 ">{postData?.post_type}</span>
                  </p>
                </div>}
                {postData?.caption_message && <div className="mt-1">
                  <p className="md:text-sm font-medium text-sm">
                    Caption Message : {' '}
                    <span className="text-gray-500 ">{postData?.caption_message}</span>
                  </p>
                </div>}
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}

export default UserDetails;
